import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/footer/Footer';
import PageTop from '../components/pageTop/PageTop';
import { PageContainer } from '../components/common/PageComponent.style';
import * as S from './landing.style';
import OtherService from './OtherService';

function QuantGuide() {
  const navigate = useNavigate();
  return (
    <PageContainer>
      <S.Container>
        <PageTop text={'퀀트 분석 기반 테마 추천(宙)'} />
        <HeroSection>
          <HeroTitleWrapper>
            <BadgeContainer>
              <MembershipBadgeStandard>
                <span>Standard</span>
              </MembershipBadgeStandard>
              <MembershipBadgePremium>
                <span>Premium</span>
              </MembershipBadgePremium>
            </BadgeContainer>
            <HeroTitle>
              데이터에 기반한
              <br />
              국내 최초 부동산 퀀트 투자
            </HeroTitle>
          </HeroTitleWrapper>
          <HeroDescription>
            수많은 경매 물건 중 어디에 투자할 지 고민되시나요?
            <br />
            퀀트 분석으로 체계적인 전략을 세우고
            <br />
            수익성도 확인해보세요
          </HeroDescription>
        </HeroSection>
        <S.Section>
          <StartSectionTextArea>
            <StartSectionTitle>이런 고민을 하고 계신가요?</StartSectionTitle>
            <StartSectionDescription>
              경매 투자할 때 생기는 고민들, 땅집고옥션의 퀀트 투자는 여러분의
              고민을 해결해드립니다.
            </StartSectionDescription>
          </StartSectionTextArea>
          <StartSectionImgWrapper>
            <img
              src="/assets/images/guide-landing/quant/speech_mobile.png"
              alt=""
            />
          </StartSectionImgWrapper>
        </S.Section>
        <UsingGuideSection>
          <ColBox $gap={8} $center style={{ paddingRight: '24px' }}>
            <UsingGuideSectionTitle>
              퀀트분석 테마추천 이용방법
            </UsingGuideSectionTitle>
            <UsingGuideSectionDescription>
              체계적인 퀀트 테마 전략을 수립하고
              <br />
              수익성도 확인해보세요
            </UsingGuideSectionDescription>
          </ColBox>
          <UsingGuide>
            <UsingGuideCard>
              <UsingGuideImgBox>
                <UsingGuideImg
                  src="/assets/images/guide-landing/quant/process_1_mobile.png"
                  alt=""
                />
              </UsingGuideImgBox>
              <UsingGuideTextArea>
                <ColBox $gap={4}>
                  <UsingGuideNumber>01</UsingGuideNumber>
                  <CardTitle>테마선택</CardTitle>
                </ColBox>
                <UsingGuideDesc>
                  12가지 테마 중 나에게 맞는 테마를 선택해 물건을 탐색해보세요.
                  테마는 하나만 선택해도, 여러개를 조합해도 좋습니다.
                </UsingGuideDesc>
              </UsingGuideTextArea>
            </UsingGuideCard>
            <UsingGuideCard>
              <UsingGuideImgBox>
                <UsingGuideImg
                  src="/assets/images/guide-landing/quant/process_2_mobile.png"
                  alt=""
                />
              </UsingGuideImgBox>
              <UsingGuideTextArea>
                <ColBox $gap={4}>
                  <UsingGuideNumber>02</UsingGuideNumber>
                  <CardTitle>테마 수익률 확인</CardTitle>
                </ColBox>
                <UsingGuideDesc>
                  지역과 물건종류를 선택해 수익률을 확인해보세요. 지역과 물건은
                  자유롭게 추가, 제외하여 전략을 고도화할 수 있습니다.
                </UsingGuideDesc>
              </UsingGuideTextArea>
            </UsingGuideCard>
            <UsingGuideCard>
              <UsingGuideImgBox>
                <UsingGuideImg
                  src="/assets/images/guide-landing/quant/process_3_mobile.png"
                  alt=""
                />
              </UsingGuideImgBox>
              <UsingGuideTextArea>
                <ColBox $gap={4}>
                  <UsingGuideNumber>03</UsingGuideNumber>
                  <CardTitle>물건별 수익성 분석</CardTitle>
                </ColBox>
                <UsingGuideDesc>
                  테마와 조건에 맞는 물건을 확인하고 각 물건의 입찰가, 매각가,
                  차익, 수익률을 비교해보세요.
                </UsingGuideDesc>
              </UsingGuideTextArea>
            </UsingGuideCard>
            <UsingGuideCard>
              <UsingGuideImgBox>
                <UsingGuideImg
                  src="/assets/images/guide-landing/quant/process_4_mobile.png"
                  alt=""
                />
              </UsingGuideImgBox>
              <UsingGuideTextArea>
                <ColBox $gap={4}>
                  <UsingGuideNumber>04</UsingGuideNumber>
                  <CardTitle>퀀트 분석 리포트</CardTitle>
                </ColBox>
                <UsingGuideDesc>
                  분석 리포트에서 예상 낙찰가, 보유기간, 대출을 포함한 비용 및
                  수익률 등 부동산 전문가 수준의 투자 전략을 세워보세요.
                </UsingGuideDesc>
              </UsingGuideTextArea>
            </UsingGuideCard>
          </UsingGuide>
        </UsingGuideSection>
        <ImgSection>
          <CtaTitle>
            데이터 기반 퀀트 분석으로
            <br />
            체계적인 투자 전략을
            <br />
            직접 경험해보세요
          </CtaTitle>
          <CtaButton onClick={() => navigate('/quant')}>
            퀀트분석 바로가기
          </CtaButton>
        </ImgSection>
        <ReportSection>
          <ReportSectionTextArea>
            <ReportDesc>샘플 보고서</ReportDesc>
            <ReportTitle>
              퀀트 분석 보고서는
              <br />
              이렇게 구성되어 있습니다
            </ReportTitle>
          </ReportSectionTextArea>
          <ReportImgContainer>
            <ReportImg
              src="/assets/images/guide-landing/quant/report_1.png"
              alt=""
              $ratio="328/397"
            />
            <ReportImg
              src="/assets/images/guide-landing/quant/report_2.png"
              alt=""
              $ratio="38/49"
            />
            <ReportImg
              src="/assets/images/guide-landing/quant/report_3.png"
              alt=""
              $ratio="41/44"
            />
            <ReportImg
              src="/assets/images/guide-landing/quant/report_4.png"
              alt=""
              $ratio="78/73"
            />
            <ReportImg
              src="/assets/images/guide-landing/quant/report_5.png"
              alt=""
              $ratio="45/97"
            />
          </ReportImgContainer>
        </ReportSection>

        <OtherService page="quant" />
        <Footer />
      </S.Container>
    </PageContainer>
  );
}

export default QuantGuide;

const HeroSection = styled.div`
  display: flex;
  padding: 40px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  background-image: url('/assets/images/guide-landing/quant/hero_bg_mobile.png');
  background-size: cover;
  background-position: center;
`;

const HeroTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const ColBox = styled.div<{ $gap?: number; $center?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap && `${$gap}px`};
  align-items: ${({ $center }) => $center && 'center'};
`;

const HeroTitle = styled.div`
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.56px;
`;

const HeroDescription = styled.div`
  width: 100%;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const BadgeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

const MembershipBadge = styled.div`
  padding: 2px;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;

  span {
    padding: 2px 8px;
    color: #fff;
    text-align: center;
    font-family: Paperlogy;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 145%; /* 20.3px */
  }
`;

const MembershipBadgeStandard = styled(MembershipBadge)`
  background: linear-gradient(94.45deg, #3cb5de 0%, #aad545 100%);

  span {
    background: linear-gradient(106deg, #00a2e7 0%, #94bf08 100%);
  }
`;

const MembershipBadgePremium = styled(MembershipBadge)`
  background: linear-gradient(94.45deg, #3f9bff 0%, #7c29fb 100%);
  span {
    background: linear-gradient(106deg, #008aff 0%, #6900f3 100%);
  }
`;

const StartSectionTextArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

const StartSectionTitle = styled.div`
  color: #222;
  font-size: 20px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.4px;
`;

const StartSectionDescription = styled.div`
  color: #222;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const StartSectionImgWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 24px;
  background: #e7f0fe;

  & > img {
    width: 100%;
    height: auto;
  }
`;

const UsingGuideSection = styled.div`
  display: flex;
  padding: 24px 0 40px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: #f0f4fa;
`;

const UsingGuideSectionTitle = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const UsingGuideSectionDescription = styled.div`
  color: #616161;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const UsingGuide = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  overflow-x: auto;
  align-items: stretch;
  padding-right: 24px;
`;

const UsingGuideCard = styled.div`
  display: flex;
  width: 280px;
  min-width: 280px;
  height: auto;
  padding: 16px 16px 24px 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
  background: #fff;
`;

const UsingGuideImgBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  background: #f5f5f7;
`;

const UsingGuideImg = styled.img`
  width: 100%;
  height: auto;
`;

const UsingGuideTextArea = styled.div`
  display: flex;
  padding: 0 4px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const UsingGuideNumber = styled.div`
  color: #024a88;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const CardTitle = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const UsingGuideDesc = styled.div`
  color: #616161;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const ImgSection = styled.div`
  display: flex;
  padding: 40px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: #4228d6
    url('/assets/images/guide-landing/quant/cta_bg_mobile.png') no-repeat
    center/cover;
`;

const CtaTitle = styled.div`
  color: #fff;
  font-size: 24px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: 0.48px;
`;

const CtaButton = styled.div`
  display: flex;
  padding: 8px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 30px;
  background: #fff;

  color: #1f0a8a;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;

  &:hover {
    background: #f2f2ff;
  }
  &:active {
    background: #c7c4ff;
  }
`;

const ReportSection = styled.div`
  display: flex;
  padding: 24px 16px 40px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const ReportSectionTextArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const ReportTitle = styled.div`
  color: #222;
  font-size: 20px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.4px;
`;

const ReportDesc = styled.div`
  color: #4228d6;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const ReportImgContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const ReportImg = styled.img<{ $ratio?: string }>`
  width: 100%;
  border-radius: 16px;
  aspect-ratio: ${({ $ratio }) => $ratio};
`;

const OtherServiceSection = styled.div`
  display: flex;
  padding: 24px 16px 72px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: #f0f4fa;
`;

const OtherServiceSectionTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  color: #222;
  font-size: 20px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.4px;

  & > span {
    color: #008aff;
    font-size: 14px;
    font-weight: 700;
    line-height: 145%;
    letter-spacing: -0.28px;
  }
`;

const OtherServiceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
`;

const ArrowButton = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  border-radius: 20px;
  background: var(--semantic-static-white, #fff);

  /* &:hover {
    background: #f2f2ff;
  }
  &:active {
    background: #c7c4ff;
  } */

  & > img {
    width: 20px;
    height: 20px;
  }
`;

const OtherServiceCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  border-radius: 24px;
  background: #fff;

  &:hover ${ArrowButton} {
    background: #f2f2ff;
  }

  &:active ${ArrowButton} {
    background: #c7c4ff;
  }
`;

const OtherServiceImgWrapper = styled.div<{ $background?: string }>`
  background-color: ${({ $background }) => $background && $background};
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  & > img {
    width: 100%;
    height: auto;
  }
`;

const OtherServiceCardTextArea = styled.div`
  display: flex;
  padding: 16px 16px 20px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const OtherServiceTitle = styled.div`
  color: #222;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const OtherServiceDesc = styled.div`
  color: #616161;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const OtherServiceButtonWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  align-self: stretch;
`;

const OtherServiceButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;

  color: #1f0a8a;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;
